var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"success"}},[(_vm.showSuccess)?_c('span',{staticClass:"success-message"},[_vm._v("\n    De link is gekopieerd naar het klembord\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }